// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.site-info[data-v-796e3c50] {\n\tpadding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
